export default __webpack_public_path__ + "static/media/dod-logo-pdf.1398c49e.png";